import type { PickerOptions } from 'filestack-js';
import type { TFunction } from 'i18next';

import type { TValidateGrouped } from '@feathr/rachis';

/** Validation errors returned by account.validate for the ProfilePage form fields. */
export interface IErrors extends TValidateGrouped {
  campaigns_max_budget?: string;
  csm?: string[];
  strategist?: string[];
  name?: string[];
  logo?: string[];
  email_health?: string[];
}

/** Represents an IAB industry category used for account classification. */
export interface IIndustryCategory {
  children?: IIndustryCategory[];
  id: number;
  name: string;
  parentCategoryId?: number | null;
  isSensitive?: boolean;
}

/** Fields passed to account.validate for ProfilePage form validation. */
export const VALIDATION_FIELDS = [
  'settings.campaigns_max_budget',
  'csm',
  'strategist',
  'name',
  'logo',
  'email_health',
] as const;

/**
 * Creates picker options for the logo ImagePicker.
 *
 * @param t - i18next translation function
 * @returns PickerOptions configured for logo image upload
 */
export function getPickerOptions(t: TFunction): PickerOptions {
  return {
    accept: ['image/gif', 'image/jpeg', 'image/png'],
    fromSources: ['local_file_system', 'url'],
    customText: {
      'Select Files to Upload': t('Upload logo file or provide logo URL'),
    },
    maxFiles: 1,
  };
}
